/* CUSTOM: make the phone number required on every contact form,
   and accept anything typed into it (no format check) */
(function () {
  function requirePhone() {
    document.querySelectorAll('form[id^="ContactForm"] input[type="tel"]').forEach(function (input) {
      if (input.dataset.phoneRequired) return;
      input.dataset.phoneRequired = 'true';
      input.required = true;
      input.setAttribute('aria-required', 'true');
      input.removeAttribute('pattern');
      input.classList.add('required');
      var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
      if (label && label.textContent.trim().slice(-1) !== '*') {
        label.textContent = label.textContent.trim() + '*';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requirePhone);
  } else {
    requirePhone();
  }
  document.addEventListener('shopify:section:load', requirePhone);
})();
